import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  AuthService,
  ErrorDetails,
  LoginTokenEligibleUser,
  UsersLoginTokenRequest
} from '@ianesthesie-kit/services';
import { wrapError } from '@/util';

export const patientBffApi = createApi({
  baseQuery: fakeBaseQuery<ErrorDetails>(),
  endpoints: (builder) => ({
    usersByLoginToken: builder.query<
      LoginTokenEligibleUser[],
      UsersLoginTokenRequest['token']
    >({
      queryFn: (token) =>
        AuthService.getInstance()
          .findEligibleUsersByLoginToken({ token })
          .then((r) => ({ data: r.data }))
          .catch(wrapError)
    })
  }),
  reducerPath: 'patientBffApi',
  refetchOnFocus: false,
  refetchOnReconnect: true,
  tagTypes: [
    'ActiveSurgicalEvent',
    'AssignedQuestionnaires',
    'AutocompleteOptions',
    'BookedSlot',
    'PaymentStatus',
    'SlotsList',
    'UserConfig',
    'MedicalDocument',
    'PrescriptionDocument',
    'InformedConsent',
    'SurgeryInfo',
    'AnesthesiaRisk',
    'TerraIntegration',
    'Invoice',
    'FollowUpPlans'
  ]
});

export const { useUsersByLoginTokenQuery: useUsersByLoginToken } =
  patientBffApi;
